import AppBarComp from '../AppBar/AppBarComp'
import { useEffect, useState } from 'react'
import { isTokenExpired } from '../../auth/utils'
import { ROUTE_SESSION_EXPIRED } from '../../routes/constants'
import useWindowFocus from '@derolfgroep/utils/lib/react/hooks/useWindowFocus'
import { useNavigate, Outlet } from 'react-router-dom'

const AppContent = () => {
  const [isSessionExpired, setSessionExpired] = useState(false)
  const windowHasFocus = useWindowFocus()
  const navigate = useNavigate()

  useEffect(() => {
    if (windowHasFocus && isTokenExpired()) {
      navigate(ROUTE_SESSION_EXPIRED)
      setSessionExpired(true)
    }
  }, [navigate, windowHasFocus])

  return (
    <>
      {!isSessionExpired && <AppBarComp />}
      <Outlet />
    </>
  )
}

export default AppContent
